import { gql } from "@apollo/client"

// Separate from PTM_MEMBERSHIP_APPLICATIONS_QUERY: a Coach Tools without
// `electionDate` rejects the whole document, which would hide every PTM status.
export const MEMBER_APPLICATION_ELECTION_DATE_QUERY = gql`
  query MemberApplicationElectionDate {
    membershipApplications(applicationType: member) {
      id
      applicationType
      status
      electionDate
      electedAt
      updatedAt
    }
  }
`
